<template>
  <div id="app">
    <!-- Remove AppHeader from here -->
    <AlertMessage />
    <AdminAlerts />
    <AppUpdateBanner />

    <router-view />
    <!-- <BottomNav v-if="$store.state.user"/> --> <!-- Remove this line -->
  </div>
</template>

<script>
import AlertMessage from './components/notifications/AlertMessage.vue';
import AdminAlerts from './components/notifications/AdminAlerts.vue';
import AppUpdateBanner from './components/notifications/AppUpdateBanner.vue';
// import BottomNav from './components/common/BottomNav.vue'; // Remove this line
// import AppHeader from './components/common/AppHeader.vue'; // Remove this line

export default {
  name: 'App',
  components: {
    AlertMessage,
    AdminAlerts,
    AppUpdateBanner,
    // BottomNav, // Remove from components
    // AppHeader, // Remove from components
  },
  data() {
    return {
      isOnline: true
    };
  },
  async created() {
    // Initialize app with required data
    await this.initializeApp();
  },
  methods: {
    async initializeApp() {
      try {
        // First fetch user and profile
        console.log('[App] Initializing app - fetching user data');
        await this.$store.dispatch('fetchUser');
        
        // Then fetch other data that depends on user being loaded
        console.log('[App] Fetching app dependencies');
        await Promise.all([
          this.$store.dispatch('fetchGlobalSettings'), // Add this line to fetch during initialization
          this.$store.dispatch('fetchCurriculaData') // Add this line to fetch curricula data
        ]);
        
        console.log('App initialized with all required data');
      } catch (error) {
        console.error('Error initializing app:', error);
        this.$store.dispatch('showAlert', {
          message: "Failed to load application data",
          type: "error"
        });
      }
    }
  },
  watch: {
    // Watch for user changes to refresh data
    '$store.state.user': {
      handler(newUser, oldUser) {
        if (newUser && (!oldUser || newUser.uid !== oldUser?.uid)) {
          console.log('[App] User changed - refreshing data');
          //// Fetch user profile and other data when user changes
        }
      },
      immediate: true
    }
  }
};
</script>


<style>

body{
  margin: 0;
  padding: 0;
  background-color: #f5f6f8;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


/* Offline banner styles */
.offline-banner {
  position: fixed;
  top: 0;
  width: 100%;
  background: red;
  color: white;
  text-align: center;
  padding: 10px;
  font-weight: bold;
  z-index: 1000;
}

input, button, select, textarea {
   outline: none;
}

.button-shadow{
     box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
}

</style>
